import { useInsertSampleEvent } from '@ion/api';

export default function useOnSubmitSampleEvent({ onClose, onSaveSuccess }) {
  const onCompleted = ({ sampleEvent }) => {
    if (onSaveSuccess) {
      onSaveSuccess(sampleEvent);
    }

    onClose();
  };

  const [insertSampleEvent] = useInsertSampleEvent({ onCompleted });

  return insertSampleEvent;
}
